import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=961dd0ae&"
import script from "./Paginator.vue?vue&type=script&lang=js&"
export * from "./Paginator.vue?vue&type=script&lang=js&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=961dd0ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports